import { combineReducers } from 'redux';
import zone from './zone';
import points from './points';

export const planReducer = combineReducers({
  zone,
  points,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/reducers/index.js